export default __webpack_public_path__ + "static/media/9.3c57b682.jpeg";